var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v("团长按绑定关系分成，代理按收货地分成。"),
          ]),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.onTabChange },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "团长", name: "leader" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth",
                            attrs: {
                              options: _vm.cityOptions,
                              props: _vm.cascaderProps,
                              clearable: "",
                              placeholder: "请选择省/市/区",
                            },
                            on: { change: _vm.onLeaderRegionChange },
                            model: {
                              value: _vm.leaderRegionIds,
                              callback: function ($$v) {
                                _vm.leaderRegionIds = $$v
                              },
                              expression: "leaderRegionIds",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidthSm",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.leaderQuery.contact,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.leaderQuery,
                                  "contact",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "leaderQuery.contact",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "审批状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidthSm",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.leaderQuery.auditStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.leaderQuery, "auditStatus", $$v)
                                },
                                expression: "leaderQuery.auditStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "待审", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "通过", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "驳回", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadLeaders(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.resetLeaders } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.leaderQuery.agentId
                    ? _c(
                        "div",
                        { staticClass: "agent-filter" },
                        [
                          _vm._v(" 正在看代理 "),
                          _c("b", [
                            _vm._v("#" + _vm._s(_vm.leaderQuery.agentId)),
                          ]),
                          _vm._v(" 名下的团长 "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: { click: _vm.clearAgentFilter },
                            },
                            [_vm._v("查看全部团长")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.leaderLoading,
                          expression: "leaderLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.leaderList,
                        border: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", width: "60", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                            },
                          },
                        ]),
                      }),
                      false
                        ? _c("el-table-column", {
                            attrs: { prop: "id", label: "ID", width: "70" },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: { label: "团长", "min-width": "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(" " + _vm._s(_vm.userName(row.uid))),
                                _c("div", { staticClass: "sub-line" }, [
                                  _vm._v(_vm._s(_vm.contact(row.uid))),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "区域", width: "140" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.distributionRegionLabel(
                                      row.regionCode,
                                      row.regionName
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "所属代理", width: "110" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                Number(row.agentId) > 0
                                  ? _c("span", [
                                      _vm._v("#" + _vm._s(row.agentId)),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [_vm._v("未绑定")]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "memberCount",
                          label: "团员数",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "累计佣金" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  "¥" + _vm._s(_vm.money(row.totalCommission))
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "可提现" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v("¥" + _vm._s(_vm.money(row.balance))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "createTime", label: "创建时间" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                Number(row.agentId) > 0
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "danger-text",
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.unbindAgent(row)
                                          },
                                        },
                                      },
                                      [_vm._v("解绑代理")]
                                    )
                                  : _c("span", { staticClass: "sub-line" }, [
                                      _vm._v("-"),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next",
                      total: Number(_vm.leaderTotal),
                      "page-size": Number(_vm.leaderQuery.size),
                      "current-page": Number(_vm.leaderQuery.page),
                    },
                    on: { "current-change": _vm.loadLeaders },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "团长申请", name: "apply" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { inline: "", size: "small" },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "城市" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth",
                            attrs: {
                              options: _vm.cityOptions,
                              props: _vm.cascaderProps,
                              clearable: "",
                              placeholder: "请选择省/市/区",
                            },
                            on: { change: _vm.onApplyRegionChange },
                            model: {
                              value: _vm.applyRegionIds,
                              callback: function ($$v) {
                                _vm.applyRegionIds = $$v
                              },
                              expression: "applyRegionIds",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidthSm",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.applyQuery.contact,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.applyQuery,
                                  "contact",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "applyQuery.contact",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidthSm",
                              attrs: { clearable: "", placeholder: "全部" },
                              model: {
                                value: _vm.applyQuery.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyQuery, "status", $$v)
                                },
                                expression: "applyQuery.status",
                              },
                            },
                            _vm._l(_vm.applyStatusOptions, function (s) {
                              return _c("el-option", {
                                key: s.value,
                                attrs: { label: s.label, value: s.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadApplies(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.resetApplies } }, [
                            _vm._v("重置"),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                loading: _vm.batchApproving,
                              },
                              on: { click: _vm.approveAll },
                            },
                            [_vm._v("一键通过")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "tips" }, [
                    _vm._v(
                      " 审批权在区域代理手上（他招的人他审），这里是平台的兜底通道：代理长期不审、 或要集中放行时用。"
                    ),
                    _c("b", [_vm._v("审批人仍记在该区代理名下")]),
                    _vm._v("，事后追溯与代理自己审批时一致。"),
                    _c("br"),
                    _vm._v(" 「一键通过」只处理"),
                    _c("b", [_vm._v("当前筛选条件下")]),
                    _vm._v(
                      "的待审申请；选了城市就只批那个区域，不选就是全平台。 "
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.applyLoading,
                          expression: "applyLoading",
                        },
                      ],
                      attrs: { data: _vm.applyList, border: "", size: "small" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "序号", width: "60", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                            },
                          },
                        ]),
                      }),
                      false
                        ? _c("el-table-column", {
                            attrs: { prop: "id", label: "ID", width: "70" },
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "申请人",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "phone",
                          label: "联系方式",
                          "min-width": "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "申请区域（省 / 市 / 区）",
                          "min-width": "240",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.distributionRegionLabel(
                                      row.regionCode,
                                      row.regionName
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "申请类型", width: "90" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  _vm._s(_vm.applyTypeText(row.applyType))
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "90" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: _vm.applyStatusTag(row.status),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.applyStatusText(row.status))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "审批备注",
                          "min-width": "160",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.platformVetoReason ||
                                        row.auditRemark ||
                                        "-"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "提交时间",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "auditTime",
                          label: "审批时间",
                          "min-width": "150",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "条件达标", width: "110" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "left",
                                      width: "300",
                                      trigger: "click",
                                    },
                                    on: {
                                      show: function ($event) {
                                        return _vm.loadConditions(row.uid)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "loading",
                                            rawName: "v-loading",
                                            value: _vm.conditionLoading,
                                            expression: "conditionLoading",
                                          },
                                        ],
                                      },
                                      [
                                        !_vm.conditionCache[row.uid]
                                          ? _c(
                                              "div",
                                              { staticClass: "sub-line" },
                                              [_vm._v("加载中…")]
                                            )
                                          : [
                                              !_vm.conditionCache[row.uid].items
                                                .length
                                                ? _c(
                                                    "div",
                                                    { staticClass: "sub-line" },
                                                    [
                                                      _vm._v(
                                                        " 平台未配置任何条件，谁都能申请 "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.conditionCache[row.uid]
                                                  .items,
                                                function (c, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: i,
                                                      staticClass: "cond-line",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(_vm._s(c.label)),
                                                      ]),
                                                      _c(
                                                        "span",
                                                        {
                                                          class: c.passed
                                                            ? "cond-ok"
                                                            : "cond-bad",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                c.passed
                                                                  ? "已达标"
                                                                  : "当前 " +
                                                                      c.actualText
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "text",
                                          size: "small",
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("查看")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "90", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                Number(row.status) === 0
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.approveOne(row)
                                          },
                                        },
                                      },
                                      [_vm._v("通过")]
                                    )
                                  : _c("span", { staticClass: "sub-line" }, [
                                      _vm._v("-"),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next",
                          total: Number(_vm.applyTotal),
                          "page-size": Number(_vm.applyQuery.size),
                          "current-page": Number(_vm.applyQuery.page),
                        },
                        on: {
                          "size-change": _vm.onApplySizeChange,
                          "current-change": _vm.loadApplies,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }